import UspCard from './UspCard';

export default UspCard;
